export const harnessDisplayStatuses = {
  not_created: { text: '未创建', status: 'Default' },
  preparing: { text: '准备中', status: 'Processing' },
  running: { text: '运行中', status: 'Success' },
  updating: { text: '更新中', status: 'Processing' },
  failed: { text: '异常', status: 'Error' },
};

const priority = { failed: 0, preparing: 1, updating: 1, running: 2, not_created: 3 };

export const filterHarnessMembers = (rows = [], query = {}) => {
  const name = (query.memberName || '').trim().toLowerCase();
  return rows
    .filter(
      (row) =>
        (!name || (row.memberName || '').toLowerCase().includes(name)) &&
        (!query.displayStatus || row.displayStatus === query.displayStatus),
    )
    .sort((a, b) => (priority[a.displayStatus] ?? 4) - (priority[b.displayStatus] ?? 4));
};

const errors = {
  HARNESS_IMAGE_PULL_FAILED: '无法获取目标版本，请检查镜像服务连接后通过“更新版本”重试。',
  HARNESS_UPGRADE_FAILED: '部分成员未完成更新，请通过“更新版本”重试。',
  HARNESS_INSTANCE_FAILED: '创作助手未能正常运行，请查看最近更新结果；持续异常时联系平台维护人员。',
  HARNESS_OWNERSHIP_CONFLICT: '运行环境存在资源冲突，请联系平台维护人员处理。',
  HARNESS_VERSION_NOT_CONFIGURED: '首次使用创作助手时自动选择版本。',
  HARNESS_NO_STABLE_VERSION: '镜像仓库暂无正式版本，请联系平台维护人员发布版本后重试。',
  HARNESS_UPGRADE_IN_PROGRESS: '组织版本正在更新，请稍后重试。',
  HARNESS_CONFIG_INVALID: '运行环境配置异常，请联系平台维护人员。',
  HARNESS_UNAVAILABLE: '运行环境暂时不可用，请稍后查看；持续异常时联系平台维护人员。',
};

export const getHarnessError = (code) =>
  code ? errors[code] || '创作助手暂时不可用，请稍后查看或联系平台维护人员。' : '';
